/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */

const ROUTES = {
  login: "/",
  base: "/",
  forgotPassword: "/forgot-password",
  createNewPassword: "/create-new-password",
  eventSwitcher: "/select-event",
  noAccess: "/no-access",
  unsubscribe: "/unsubscribe_from_mailing_list",
  welcome: "/welcome",
  registerLink: {
    base: "/register-link",
    signup: "/register-link/signup",
    verifyLink: "/register-link/verify",
    done: "/register-link/done",
  },
  onboard: {
    base: "/onboard",
    // no need to make the below dynamic because they only depend only on the user, not the companions.
    invitation: "/onboard/invitation",
    registration: "/onboard/registration",
    personalInfo: (userId: string) => `/onboard/info/${userId}`,
    done: "/onboard/done",
    exit: "/onboard/exit",
  },
  dashboard: {
    base: "/dashboard",
    notifications: "/dashboard/notifications",
    guest: (userId: string) => `/dashboard/guest/${userId}`,
    reviewInfo: (userId: string) => `/dashboard/info/${userId}`,
    guestPreferences: (userId: string) =>
      `/dashboard/guest/preferences/${userId}`,
    flight: (userId: string | number, flightId: string | number) =>
      `/dashboard/guest/flight/${userId}/${flightId}`,
    generalFlight: (userId: string | number, flightId: string | number) =>
      `/dashboard/guest/flight/${userId}/${flightId}`,
    reservation: (userId: string | number, reservationId: string | number) =>
      `/dashboard/guest/reservation/${userId}/${reservationId}`,
    generalReservation: (
      userId: string | number,
      reservationId: string | number,
    ) => `/dashboard/guest/reservation/${userId}/${reservationId}`,
  },
  webpages: {
    base: (pageSlug: string) => `/pages/${pageSlug}`,
  },
  choices: {
    base: (userId: string) => `/choices/${userId}`,
    preferences: (userId: string) => `/choices/preferences/${userId}`,
    allergies: (userId: string) => `/choices/allergies/${userId}`,
    generalAllergies: (userId: string) =>
      `/choices/general-allergies/${userId}`,
    medicalConditions: (userId: string) =>
      `/choices/medical-conditions/${userId}`,
    notes: (userId: string) => `/choices/notes/${userId}`,
  },
};

export const GUEST_CHOICES_PAGES = [
  "choices",
  "preferences",
  "allergies",
  "general-allergies",
  "medical-conditions",
  "notes",
];

export default ROUTES;
export { default as RoutesWrapper } from "./RoutesWrapper";
